"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DriverWheel = function DriverWheel() {
  return _react2.default.createElement(
    "g",
    { id: "driverWheel" },
    _react2.default.createElement("path", {
      d: "M424.458 297.326c4.135 0 8.222.262 12.243.655-19.92 59.09-69.36 105.25-131.61 122.64-.2-2.71-.34-5.42-.34-8.18 0-63.57 53.6-115.11 119.72-115.11h-.003zm-348.273 0c66.117 0 119.718 51.54 119.718 115.112 0 2.758-.14 5.463-.337 8.178C133.306 403.23 83.868 357.064 63.94 297.98c4.028-.392 8.114-.654 12.245-.654zm174.136-88.95c24.05 0 43.54 18.743 43.54 41.86 0 23.116-19.49 41.858-43.53 41.858-24.04 0-43.532-18.742-43.532-41.86 0-23.115 19.49-41.857 43.534-41.857zm0-156.97c88.96 0 164.02 56.97 187.91 135.063-49.43-18.89-115.39-30.42-187.91-30.42-72.51 0-138.47 11.52-187.9 30.41C86.31 108.37 161.37 51.4 250.33 51.4zm0-52.323C112.08-.917 0 106.843 0 239.77s112.073 240.69 250.32 240.69c138.25 0 250.322-107.762 250.322-240.69 0-132.927-112.073-240.687-250.32-240.687z",
      id: "Shape"
    })
  );
};

exports.default = DriverWheel;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/DriverWheel.js
// module id = 2941
// module chunks = 4